import { AfterContentInit, AfterViewChecked, Component, ContentChild, Renderer2, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApxPrefixDirective } from '../directives/apx-prefix.directive';
import { ApxInputDirective } from '../input.directive';
import { ApxSuffixDirective } from '../directives/apx-suffix.directive';

@Component({
    selector: 'apx-input-group',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './input-group.component.html'
})
export class ApxInputGroupComponent implements AfterContentInit, AfterViewChecked {
    private readonly renderer = inject(Renderer2);

    @ContentChild(ApxPrefixDirective, { descendants: true })
    prefixChild!: ApxPrefixDirective;
    @ContentChild(ApxSuffixDirective, { descendants: true })
    suffixChild!: ApxSuffixDirective;
    @ContentChild(ApxInputDirective) input!: ApxInputDirective;
    hasPrefixIcon = false;
    hasSuffixIcon = false;
    inputSize: 'small' | 'standard' = 'small';

    ngAfterViewChecked() {
        this.inputSize = this.input.elemRef.nativeElement.getAttribute('class').includes('x-w-input_standard') ? 'standard' : 'small';
    }

    ngAfterContentInit(): void {
        this.hasPrefixIcon = this.prefixChild ? true : false;
        this.hasSuffixIcon = this.suffixChild ? true : false;

        if (this.hasPrefixIcon) {
            this.renderer.addClass(this.input.elemRef.nativeElement, 'pl-8');
        }
        if (this.hasSuffixIcon) {
            this.renderer.addClass(this.input.elemRef.nativeElement, 'pr-8');
        }
    }
}
